/** Superficie pública de shared/product-search. */
export { CatalogStockProductSearchFields } from './components/CatalogStockProductSearchFields';
export type { CatalogStockProductSearchFieldsProps, ProductSearchRow } from './components/CatalogStockProductSearchFields';
export { ProductSearchPinnedChip } from './components/ProductSearchPinnedChip';
export { ProductSearchSuggestionsPanel } from './components/ProductSearchSuggestionsPanel';
export type { ProductSearchSuggestionItem } from './components/ProductSearchSuggestionsPanel';
export {
  BARCODE_SCAN_LOCK_MS,
  BARCODE_INTER_READ_LOCK_MS,
  BARCODE_MULTI_SCAN_MAX_MISMATCHES,
  looksLikeBarcodeHardwareSubmit,
  createBarcodeScanDedupe,
  shouldSelectAllAfterBarcodeFieldValueChange,
} from './productBarcodeInput';
export type { BarcodeScanDedupe } from './productBarcodeInput';
export {
  MIN_PRODUCT_SEARCH_QUERY_CHARS,
  PRODUCT_SEARCH_DEBOUNCE_MS,
  effectiveProductSearchQuery,
  productSearchEmptyMessage,
} from './productSearchUx';
